export default __webpack_public_path__ + "static/media/icon-handshake.fd56defa.svg";